import { Observable } from 'rxjs';
import { IBetByDraw, IBlock, CURRENCY, IDrawStats, WALLET_CODE, IWallet } from '../interfaces';
import { ICurrency } from './accounts.interfaces';
import { IBet, IDrawUserBets, IUserTicket } from './bets.interfaces';
import { IUserSimpled } from './user.interfaces';

export enum DRAW_SCHEDULE {
  SOUTH_AMERICA, //0
  EUROPE, //1
  ASIA, //2
  RIO, //3
  LOOK, //4
  LN, //5
  LBR, //6
  LDB24,
  LDBEXPRESS,
}
export const BANCAS_ARRAY = ['SOUTH_AMERICA', 'EUROPE', 'ASIA', 'RIO', 'LOOK', 'LN', 'LBR', 'LDB24', 'LDBEXPRESS'];
export enum BANCAS {
  SOUTH_AMERICA = 'SOUTH_AMERICA',
  EUROPE = 'EUROPE',
  ASIA = 'ASIA',
  RIO = 'RIO',
  LOOK = 'LOOK',
  LN = 'LN',
  LBR = 'LBR',
  LDB24 = 'LDB24',
  LDBEXPRESS = 'LDBEXPRESS',
}

export interface IWalletDubHistorical {
  dubs: IDrawUserBets[];
  byDay: { timestamp: number; bets: IBet[] };
  offset: number;
  limit: number;
  total: number;
  wallet: WALLET_CODE;
}
export interface IBrazilDrawsCalendar {
  month: string;
  FED: number[];
  holidays: number[];
}
export interface IDayEvaluatedBets {
  day_ts: number;
  bets$: Observable<IBet[]>;
  num_bets: number;
  show?: boolean;
  loading?: boolean;
  date_desc?: string;
  currency: CURRENCY;
}
export interface IAnimal {
  numbers: string[];
  group: number;
  image?: string;
}
export interface ICurrencySpot {
  spot: string;
  rate: number;
  timestamp: number;
}
export interface IDrawSchedule {
  banca: BANCAS;
  index: number;
  denom: DRAW_SCHEDULE;
  denominations: DRAW_DENOMINATION[];
  offset: number;
  zone: string;
  // _id: string;
  // production: boolean;
  // test: boolean;
  // background: string;
  // es: string;
  // pt: string;
  // en: string;
}
export interface IDrawBase {
  denomination: DRAW_DENOMINATION;
  schedules: any;
  hour: string;
  label: string;
  // week: number[];
  // _id: string;
  // note: string;
  // prevMinAcceptBet: number;
  // es: string;
  // en: string;
  // pt: string;
}
export interface IDraw {
  _id?: string;
  schedule: DRAW_SCHEDULE;
  desc: string;
  denomination: DRAW_DENOMINATION;
  day_timestamp: number;
  draw_timestamp: number;
  num_bets?: number;
  result?: IDrawResult;
  selected?: boolean;
  onNewBet?: boolean;
  loading?: boolean;
  prevMinAcceptBet?: number;
  limit_bet_timestamp?: number;
  drawBase?: IDrawBase;
  hour?: string;
}
export interface IDrawResult {
  block: IBlock;
  prizes?: IPrizes;
  drawHash: string;
  prevDrawHash?: string;
  num_bets?: number;
  stats: IDrawStats;
  start_proccessing: number;
  timestamp: number;
  speed: number;
  allPrizes?: string[];
  allAnimals?: IAnimal[];
}
export interface IResult {
  _id?: string;
  date: string;
  timestamp: number;
  header: string[];
  prices: any;
  table: any;
}
export interface IDrawTable {
  draws: IDraw[];
  timestamp: number;
  schedule: IDrawSchedule;
  lang?: string;
}
export interface IPrizes {
  prizes: string[];
  moderno: string;
  rio: string;
  salteado: string;
  all?: string[];
  groups?: number[];
}
export interface IDrawOffset {
  draw_denomitation: DRAW_DENOMINATION;
  offset: number;
}
export interface IDrawsResult {
  banca: BANCAS;
  prizes: IPrizes;
  denomination: DRAW_DENOMINATION;
  schedule: DRAW_SCHEDULE;
  day_timestamp: number;
  draw_timestamp: number;
}
export interface IBySchedules {
  schedule: DRAW_SCHEDULE;
  betsByDraw: IBetByDraw[];
}
export interface IDrawData {
  draw: IDraw;
  bets: IBet[];
  done: boolean;
  tickets: IUserTicket[];
  numBets: number;
}
export interface IDrawCurrenciesInfo {
  draw: IDraw;
  currencies: ICurrencyResult[];
  num_users: number;
  users: IUserSimpled[];
}
export interface ICurrencyResult {
  currency: CURRENCY | ICurrency;
  wallet: IWallet;
  _bets?: IBet[];
  w_bets?: IBet[];
  num_bets: number;
  num_winning_bets: number;
  num_users: number;
  amount_beted: number;
  amount_winned: number;
  num_users_winning: number;
  max_bet_amount: number;
  max_winning_amount: number;
  perc_house?: number;
  perc_wining?: number;
}

export enum DRAW_DENOMINATION {
  PTM,
  PT,
  PTV,
  PTN,
  COR,
  FED,
  LOOK_11,
  LOOK_14,
  LOOK_16,
  LOOK_18,
  LOOK_21,

  LDB24_0, //11
  LDB24_1,
  LDB24_2,
  LDB24_3,
  LDB24_4,
  LDB24_5,
  LDB24_6,
  LDB24_7,
  LDB24_8,
  LDB24_9,
  LDB24_10,
  LDB24_11,
  LDB24_12,
  LDB24_13,
  LDB24_14,
  LDB24_15,
  LDB24_16,
  LDB24_17,
  LDB24_18,
  LDB24_19,
  LDB24_20,
  LDB24_21,
  LDB24_22,
  LDB24_23, //34

  LBR_8_30,
  LBR_10_00,
  LBR_12_40,
  LBR_15_00,
  LBR_17_00,
  LBR_19_00,
  LBR_20_40,
  LBR_22_00,
  LBR_23_30,

  LN_8_00,
  LN_10_00,
  LN_12_00,
  LN_15_00,
  LN_17_00,
  LN_20_00,
  LN_23_00, //50
  LDBEXPRESS_00_00, //51
  LDBEXPRESS_00_05,
  LDBEXPRESS_00_10,
  LDBEXPRESS_00_15,
  LDBEXPRESS_00_20,
  LDBEXPRESS_00_25,
  LDBEXPRESS_00_30,
  LDBEXPRESS_00_35,
  LDBEXPRESS_00_40,
  LDBEXPRESS_00_45,
  LDBEXPRESS_00_50,
  LDBEXPRESS_00_55,
  LDBEXPRESS_01_00,
  LDBEXPRESS_01_05,
  LDBEXPRESS_01_10,
  LDBEXPRESS_01_15,
  LDBEXPRESS_01_20,
  LDBEXPRESS_01_25,
  LDBEXPRESS_01_30,
  LDBEXPRESS_01_35,
  LDBEXPRESS_01_40,
  LDBEXPRESS_01_45,
  LDBEXPRESS_01_50,
  LDBEXPRESS_01_55,
  LDBEXPRESS_02_00,
  LDBEXPRESS_02_05,
  LDBEXPRESS_02_10,
  LDBEXPRESS_02_15,
  LDBEXPRESS_02_20,
  LDBEXPRESS_02_25,
  LDBEXPRESS_02_30,
  LDBEXPRESS_02_35,
  LDBEXPRESS_02_40,
  LDBEXPRESS_02_45,
  LDBEXPRESS_02_50,
  LDBEXPRESS_02_55,
  LDBEXPRESS_03_00,
  LDBEXPRESS_03_05,
  LDBEXPRESS_03_10,
  LDBEXPRESS_03_15,
  LDBEXPRESS_03_20,
  LDBEXPRESS_03_25,
  LDBEXPRESS_03_30,
  LDBEXPRESS_03_35,
  LDBEXPRESS_03_40,
  LDBEXPRESS_03_45,
  LDBEXPRESS_03_50,
  LDBEXPRESS_03_55,
  LDBEXPRESS_04_00,
  LDBEXPRESS_04_05,
  LDBEXPRESS_04_10,
  LDBEXPRESS_04_15,
  LDBEXPRESS_04_20,
  LDBEXPRESS_04_25,
  LDBEXPRESS_04_30,
  LDBEXPRESS_04_35,
  LDBEXPRESS_04_40,
  LDBEXPRESS_04_45,
  LDBEXPRESS_04_50,
  LDBEXPRESS_04_55,
  LDBEXPRESS_05_00,
  LDBEXPRESS_05_05,
  LDBEXPRESS_05_10,
  LDBEXPRESS_05_15,
  LDBEXPRESS_05_20,
  LDBEXPRESS_05_25,
  LDBEXPRESS_05_30,
  LDBEXPRESS_05_35,
  LDBEXPRESS_05_40,
  LDBEXPRESS_05_45,
  LDBEXPRESS_05_50,
  LDBEXPRESS_05_55,
  LDBEXPRESS_06_00,
  LDBEXPRESS_06_05,
  LDBEXPRESS_06_10,
  LDBEXPRESS_06_15,
  LDBEXPRESS_06_20,
  LDBEXPRESS_06_25,
  LDBEXPRESS_06_30,
  LDBEXPRESS_06_35,
  LDBEXPRESS_06_40,
  LDBEXPRESS_06_45,
  LDBEXPRESS_06_50,
  LDBEXPRESS_06_55,
  LDBEXPRESS_07_00,
  LDBEXPRESS_07_05,
  LDBEXPRESS_07_10,
  LDBEXPRESS_07_15,
  LDBEXPRESS_07_20,
  LDBEXPRESS_07_25,
  LDBEXPRESS_07_30,
  LDBEXPRESS_07_35,
  LDBEXPRESS_07_40,
  LDBEXPRESS_07_45,
  LDBEXPRESS_07_50,
  LDBEXPRESS_07_55,
  LDBEXPRESS_08_00,
  LDBEXPRESS_08_05,
  LDBEXPRESS_08_10,
  LDBEXPRESS_08_15,
  LDBEXPRESS_08_20,
  LDBEXPRESS_08_25,
  LDBEXPRESS_08_30,
  LDBEXPRESS_08_35,
  LDBEXPRESS_08_40,
  LDBEXPRESS_08_45,
  LDBEXPRESS_08_50,
  LDBEXPRESS_08_55,
  LDBEXPRESS_09_00,
  LDBEXPRESS_09_05,
  LDBEXPRESS_09_10,
  LDBEXPRESS_09_15,
  LDBEXPRESS_09_20,
  LDBEXPRESS_09_25,
  LDBEXPRESS_09_30,
  LDBEXPRESS_09_35,
  LDBEXPRESS_09_40,
  LDBEXPRESS_09_45,
  LDBEXPRESS_09_50,
  LDBEXPRESS_09_55,
  LDBEXPRESS_10_00,
  LDBEXPRESS_10_05,
  LDBEXPRESS_10_10,
  LDBEXPRESS_10_15,
  LDBEXPRESS_10_20,
  LDBEXPRESS_10_25,
  LDBEXPRESS_10_30,
  LDBEXPRESS_10_35,
  LDBEXPRESS_10_40,
  LDBEXPRESS_10_45,
  LDBEXPRESS_10_50,
  LDBEXPRESS_10_55,
  LDBEXPRESS_11_00,
  LDBEXPRESS_11_05,
  LDBEXPRESS_11_10,
  LDBEXPRESS_11_15,
  LDBEXPRESS_11_20,
  LDBEXPRESS_11_25,
  LDBEXPRESS_11_30,
  LDBEXPRESS_11_35,
  LDBEXPRESS_11_40,
  LDBEXPRESS_11_45,
  LDBEXPRESS_11_50,
  LDBEXPRESS_11_55,
  LDBEXPRESS_12_00,
  LDBEXPRESS_12_05,
  LDBEXPRESS_12_10,
  LDBEXPRESS_12_15,
  LDBEXPRESS_12_20,
  LDBEXPRESS_12_25,
  LDBEXPRESS_12_30,
  LDBEXPRESS_12_35,
  LDBEXPRESS_12_40,
  LDBEXPRESS_12_45,
  LDBEXPRESS_12_50,
  LDBEXPRESS_12_55,
  LDBEXPRESS_13_00,
  LDBEXPRESS_13_05,
  LDBEXPRESS_13_10,
  LDBEXPRESS_13_15,
  LDBEXPRESS_13_20,
  LDBEXPRESS_13_25,
  LDBEXPRESS_13_30,
  LDBEXPRESS_13_35,
  LDBEXPRESS_13_40,
  LDBEXPRESS_13_45,
  LDBEXPRESS_13_50,
  LDBEXPRESS_13_55,
  LDBEXPRESS_14_00,
  LDBEXPRESS_14_05,
  LDBEXPRESS_14_10,
  LDBEXPRESS_14_15,
  LDBEXPRESS_14_20,
  LDBEXPRESS_14_25,
  LDBEXPRESS_14_30,
  LDBEXPRESS_14_35,
  LDBEXPRESS_14_40,
  LDBEXPRESS_14_45,
  LDBEXPRESS_14_50,
  LDBEXPRESS_14_55,
  LDBEXPRESS_15_00,
  LDBEXPRESS_15_05,
  LDBEXPRESS_15_10,
  LDBEXPRESS_15_15,
  LDBEXPRESS_15_20,
  LDBEXPRESS_15_25,
  LDBEXPRESS_15_30,
  LDBEXPRESS_15_35,
  LDBEXPRESS_15_40,
  LDBEXPRESS_15_45,
  LDBEXPRESS_15_50,
  LDBEXPRESS_15_55,
  LDBEXPRESS_16_00,
  LDBEXPRESS_16_05,
  LDBEXPRESS_16_10,
  LDBEXPRESS_16_15,
  LDBEXPRESS_16_20,
  LDBEXPRESS_16_25,
  LDBEXPRESS_16_30,
  LDBEXPRESS_16_35,
  LDBEXPRESS_16_40,
  LDBEXPRESS_16_45,
  LDBEXPRESS_16_50,
  LDBEXPRESS_16_55,
  LDBEXPRESS_17_00,
  LDBEXPRESS_17_05,
  LDBEXPRESS_17_10,
  LDBEXPRESS_17_15,
  LDBEXPRESS_17_20,
  LDBEXPRESS_17_25,
  LDBEXPRESS_17_30,
  LDBEXPRESS_17_35,
  LDBEXPRESS_17_40,
  LDBEXPRESS_17_45,
  LDBEXPRESS_17_50,
  LDBEXPRESS_17_55,
  LDBEXPRESS_18_00,
  LDBEXPRESS_18_05,
  LDBEXPRESS_18_10,
  LDBEXPRESS_18_15,
  LDBEXPRESS_18_20,
  LDBEXPRESS_18_25,
  LDBEXPRESS_18_30,
  LDBEXPRESS_18_35,
  LDBEXPRESS_18_40,
  LDBEXPRESS_18_45,
  LDBEXPRESS_18_50,
  LDBEXPRESS_18_55,
  LDBEXPRESS_19_00,
  LDBEXPRESS_19_05,
  LDBEXPRESS_19_10,
  LDBEXPRESS_19_15,
  LDBEXPRESS_19_20,
  LDBEXPRESS_19_25,
  LDBEXPRESS_19_30,
  LDBEXPRESS_19_35,
  LDBEXPRESS_19_40,
  LDBEXPRESS_19_45,
  LDBEXPRESS_19_50,
  LDBEXPRESS_19_55,
  LDBEXPRESS_20_00,
  LDBEXPRESS_20_05,
  LDBEXPRESS_20_10,
  LDBEXPRESS_20_15,
  LDBEXPRESS_20_20,
  LDBEXPRESS_20_25,
  LDBEXPRESS_20_30,
  LDBEXPRESS_20_35,
  LDBEXPRESS_20_40,
  LDBEXPRESS_20_45,
  LDBEXPRESS_20_50,
  LDBEXPRESS_20_55,
  LDBEXPRESS_21_00,
  LDBEXPRESS_21_05,
  LDBEXPRESS_21_10,
  LDBEXPRESS_21_15,
  LDBEXPRESS_21_20,
  LDBEXPRESS_21_25,
  LDBEXPRESS_21_30,
  LDBEXPRESS_21_35,
  LDBEXPRESS_21_40,
  LDBEXPRESS_21_45,
  LDBEXPRESS_21_50,
  LDBEXPRESS_21_55,
  LDBEXPRESS_22_00,
  LDBEXPRESS_22_05,
  LDBEXPRESS_22_10,
  LDBEXPRESS_22_15,
  LDBEXPRESS_22_20,
  LDBEXPRESS_22_25,
  LDBEXPRESS_22_30,
  LDBEXPRESS_22_35,
  LDBEXPRESS_22_40,
  LDBEXPRESS_22_45,
  LDBEXPRESS_22_50,
  LDBEXPRESS_22_55,
  LDBEXPRESS_23_00,
  LDBEXPRESS_23_05,
  LDBEXPRESS_23_10,
  LDBEXPRESS_23_15,
  LDBEXPRESS_23_20,
  LDBEXPRESS_23_25,
  LDBEXPRESS_23_30,
  LDBEXPRESS_23_35,
  LDBEXPRESS_23_40,
  LDBEXPRESS_23_45,
  LDBEXPRESS_23_50,
  LDBEXPRESS_23_55, //338
  PPT, //339
}
